import React, {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import arrowLeft from '../../assets/icons/arrow-left.svg'
import Form from '../../components/student/AddForm'
import '../../styles/css/add-karyawan.css'
import Sidebar from '../../components/sidebar/Sidebar'

import { getDetailPenilaianGuru } from '../../features/penilaianGuruSlice'
import { useDispatch, useSelector } from 'react-redux'
import LoadingFullscreen from "../../components/LoadingFullscreen";


const PRIMARY = '#3661EB'
const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'

const navItems = [
    { label: 'Dashboard', active: false, icon: '⊞' },
    { label: 'Kehadiran', active: false, icon: '👤' },
    { label: 'Karyawan', active: false, icon: '🧑' },
    { label: 'Jurnal Guru', active: false, icon: '📋' },
    { label: 'Kalender', active: false, icon: '📅' },
    { label: 'Jadwal Guru', active: true, icon: '📆' },
    { label: 'Siswa', active: false, icon: '🎓' },
    { label: 'Logout', active: false, icon: '↩' },
]

const teachers = [
    { initials: 'SU', color: '#058257', bgColor: '#E0FEF0', name: 'Samuel Umtiti', role: 'Guru Matematika', niy: '12345679', mapel: 'Matematika', nilai: 3 },
    { initials: 'MF', color: '#058257', bgColor: '#E0FEF0', name: 'Muhammad Firdan Azhari', role: 'Guru Produktif', niy: '12345680', mapel: 'Android Development', nilai: 5 },
    { initials: 'BS', color: '#058257', bgColor: '#E0FEF0', name: 'Budi Santoso', role: 'Guru Bahasa Indonesia', niy: '12345681', mapel: 'Bahasa Indonesia', nilai: 15 },
    { initials: 'RW', color: '#B86B03', bgColor: '#FFF6E0', name: 'Rina Wulandari', role: 'Guru Fisika', niy: '12345682', mapel: 'Fisika', nilai: 9, accentColor: '#F29E12' },
]
function DetailPenialaianGuru() {
    let userId = useParams()
    let navigate = useNavigate()
    const dispatch = useDispatch()
    const {
        detailPenilaianGuru,
        isLoadingDetail
    } = useSelector((state) => state.penilaianGuruSlice)


    useEffect(() => {
        dispatch(getDetailPenilaianGuru(userId.id))

    }, [])




    function handleBack() {

            navigate(-1)

    }

    return (
        <div className='wrapper-karyawan'>
            <Sidebar />
            <div className='add-karyawan'>
                {/*{isDisplayMessage &&*/}
                {/*    <InfoBox*/}
                {/*        message={messageResApi}*/}
                {/*        status={statusResApi}*/}
                {/*        isDisplay={isDisplayMessage}*/}
                {/*        setIsDisplay={updateStateSiswa}*/}
                {/*        stateName='isDisplayMessage'*/}
                {/*    />*/}
                {/*}*/}

                <div className='navigation'>
                    <div>
                        <div className='wrapper-img' onClick={handleBack}>
                            <img src={arrowLeft} alt="" />
                        </div>
                        <h1>Detail Penilaian Guru</h1>
                    </div>


                </div>

                {/* Content */}


                {
                (isLoadingDetail) ?
                 <LoadingFullscreen loading={isLoadingDetail} />:

                    <div className='form' style={{width: '100%'}}>

                        {/* Profile Card */}
                        <div style={{
                            background: '#fff', borderRadius: 16, overflow: 'hidden',
                            boxShadow: '0px 4px 16px rgba(38,56,115,0.07)',
                            display: 'flex', alignItems: 'center', height: 150, marginBottom: 24, position: 'relative',
                        }}>
                            <div style={{ width: 4, background: PRIMARY, alignSelf: 'stretch', flexShrink: 0 }} />
                            {/* Avatar */}
                            <div style={{
                                width: 64, height: 64, borderRadius: '50%', background: '#EEF1FE',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 20px', flexShrink: 0,
                            }}>
                                <span style={{ fontSize: 18, fontWeight: 700, color: PRIMARY }}>AK</span>
                            </div>
                            {/* Info */}
                            <div style={{ flex: 1 }}>
                                <p style={{ margin: '0 0 2px', fontSize: 9, fontWeight: 500, color: '#99A6BF', letterSpacing: 1 }}>PROFIL GURU YANG DINILAI</p>
                                <h3 style={{ margin: '0 0 6px', fontSize: 18, fontWeight: 700, color: '#1A223E' }}>{detailPenilaianGuru.teacher.nama}</h3>
                                <div style={{
                                    display: 'inline-block', background: '#EEF1FE', borderRadius: 6,
                                    padding: '4px 8px', marginBottom: 8,
                                }}>
                                    <span style={{ fontSize: 10, fontWeight: 500, color: PRIMARY }}>{detailPenilaianGuru.teacher.jabatan}</span>
                                </div>
                                <p style={{ margin: 0, fontSize: 11, color: '#9BA4B7' }}>{"NIY: " + detailPenilaianGuru.teacher.niy} &nbsp;·&nbsp; {"Mapel: " + detailPenilaianGuru.teacher.mapel}</p>
                            </div>
                            {/* Divider */}
                            <div style={{ width: 1, height: 110, background: '#EAECF1', flexShrink: 0, margin: '0 10px 0 0' }} />
                            {/* Stats */}


                            <div style={{ display: 'flex', gap: 8, paddingRight: 20, alignItems: 'center' }}>
                                {[
                                    { bg: '#EEF1FE', label: 'Total Dinilai', value: detailPenilaianGuru.stats.total_dinilai, color: PRIMARY },
                                    { bg: '#E0FEF0', label: 'Total Menilai', value: detailPenilaianGuru.stats.total_menilai, color: '#058257' },
                                    { bg: '#FFF6E0', label: 'Selesai', value: detailPenilaianGuru.stats.selesai, color: '#B86B03' },
                                    { bg: '#F4F1FF', label: 'Rata Nilai', value: detailPenilaianGuru.stats.rata_nilai, color: '#6232C8' },
                                ].map((stat, i) => (
                                    <div key={i} style={{
                                        background: stat.bg, borderRadius: 12, width: 108, height: 110,
                                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                                    }}>
                                        <p style={{ margin: '0 0 4px', fontSize: 10, color: '#9BA4B7', textAlign: 'center' }}>{stat.label}</p>
                                        <p style={{ margin: 0, fontSize: 24, fontWeight: 700, color: stat.color }}>{stat.value}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Section heading */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                            <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: '#1A223E' }}>Daftar Guru Penilai</h3>
                            <div style={{ background: '#EEF1FE', borderRadius: 20, padding: '2px 10px' }}>
                                <span style={{ fontSize: 11, fontWeight: 600, color: PRIMARY }}>{detailPenilaianGuru.daftar_penilai.length}</span>
                            </div>
                        </div>

                        {
                            detailPenilaianGuru.daftar_penilai.length == 0 ?<p style={{textAlign:'center', color:'#9b9b9b',fontSize:'14px'}}>Tidak Ada Data</p>:

                            <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0px 4px 16px rgba(38,56,115,0.07)' }}>
                        {detailPenilaianGuru.daftar_penilai.map((t, i) => (
                            <div key={i}>
                                {i > 0 && <div style={{ height: 1, background: '#EEEFF3', margin: '0 20px' }} />}
                                <div style={{ display: 'flex', alignItems: 'center', height: 80, position: 'relative' }}>
                                    {/* Left accent */}
                                    <div style={{ width: 4, background: t.accentColor || '#058257', alignSelf: 'stretch', flexShrink: 0 }} />
                                    {/* Avatar */}
                                    <div style={{
                                        width: 44, height: 44, borderRadius: '50%', background: "#E0FEF0",
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        margin: '0 12px 0 16px', flexShrink: 0,
                                    }}>
                                                    <span style={{ fontSize: 13, fontWeight: 700, color: "#058257" }}>{t.nama  .split(" ")
                                                        .map(word => word[0])
                                                        .join("")
                                                        .toUpperCase()
                                                    }</span>
                                    </div>
                                    {/* Name & role */}
                                    <div style={{ flex: 1 }}>
                                        <p style={{ margin: '0 0 2px', fontSize: 13, fontWeight: 600, color: '#1A223E' }}>{t.nama}</p>
                                        <p style={{ margin: '0 0 2px', fontSize: 10, fontWeight: 500, color: PRIMARY }}>{t.jabatan}</p>
                                        <p style={{ margin: 0, fontSize: 10, color: '#9BA4B7' }}>NIY: {t.niy}</p>
                                    </div>
                                    {/* Divider */}
                                    <div style={{ width: 1, height: 48, background: '#EDEEF2', flexShrink: 0, margin: '0 16px' }} />
                                    {/* Mapel */}
                                    <div style={{ width: 200, flexShrink: 0 }}>
                                        <p style={{ margin: '0 0 4px', fontSize: 10, color: '#9BA4B7' }}>Mapel</p>
                                        <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: '#1A223E' }}>{t.mapel ?? "-"}</p>
                                    </div>
                                    {/* Divider */}
                                    <div style={{ width: 1, height: 48, background: '#EDEEF2', flexShrink: 0, margin: '0 16px' }} />
                                    {/* Nilai */}
                                    <div style={{ width: 100, flexShrink: 0, paddingRight: 20 }}>
                                        <p style={{ margin: '0 0 4px', fontSize: 10, color: '#9BA4B7' }}>Nilai</p>
                                        <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: PRIMARY }}>{t.nilai}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>


                }


                        {/* Section heading */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                            <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: '#1A223E' }}>Daftar Guru Dinilai</h3>
                            <div style={{ background: '#EEF1FE', borderRadius: 20, padding: '2px 10px' }}>
                                <span style={{ fontSize: 11, fontWeight: 600, color: PRIMARY }}>{detailPenilaianGuru.daftar_dinilai.length}</span>
                            </div>
                        </div>
                        {
                            detailPenilaianGuru.daftar_dinilai.length ?
                                <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0px 4px 16px rgba(38,56,115,0.07)' }}>
                                    {detailPenilaianGuru.daftar_dinilai.map((t, i) => (
                                        <div key={i}>
                                            {i > 0 && <div style={{ height: 1, background: '#EEEFF3', margin: '0 20px' }} />}
                                            <div style={{ display: 'flex', alignItems: 'center', height: 80, position: 'relative' }}>
                                                {/* Left accent */}
                                                <div style={{ width: 4, background: t.accentColor || '#058257', alignSelf: 'stretch', flexShrink: 0 }} />
                                                {/* Avatar */}
                                                <div style={{
                                                    width: 44, height: 44, borderRadius: '50%', background: "#E0FEF0",
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    margin: '0 12px 0 16px', flexShrink: 0,
                                                }}>
                                                    <span style={{ fontSize: 13, fontWeight: 700, color: "#058257" }}>{t.nama  .split(" ")
                                                        .map(word => word[0])
                                                        .join("")
                                                        .toUpperCase()
                                                    }</span>
                                                </div>
                                                {/* Name & role */}
                                                <div style={{ flex: 1 }}>
                                                    <p style={{ margin: '0 0 2px', fontSize: 13, fontWeight: 600, color: '#1A223E' }}>{t.nama}</p>
                                                    <p style={{ margin: '0 0 2px', fontSize: 10, fontWeight: 500, color: PRIMARY }}>{t.jabatan}</p>
                                                    <p style={{ margin: 0, fontSize: 10, color: '#9BA4B7' }}>NIY: {t.niy}</p>
                                                </div>
                                                {/* Divider */}
                                                <div style={{ width: 1, height: 48, background: '#EDEEF2', flexShrink: 0, margin: '0 16px' }} />
                                                {/* Mapel */}
                                                <div style={{ width: 200, flexShrink: 0 }}>
                                                    <p style={{ margin: '0 0 4px', fontSize: 10, color: '#9BA4B7' }}>Mapel</p>
                                                    <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: '#1A223E' }}>{t.mapel ?? "-"}</p>
                                                </div>
                                                {/* Divider */}
                                                <div style={{ width: 1, height: 48, background: '#EDEEF2', flexShrink: 0, margin: '0 16px' }} />
                                                {/* Nilai */}
                                                <div style={{ width: 100, flexShrink: 0, paddingRight: 20 }}>
                                                    <p style={{ margin: '0 0 4px', fontSize: 10, color: '#9BA4B7' }}>Nilai</p>
                                                    <p style={{ margin: 0, fontSize: 22, fontWeight: 700, color: PRIMARY }}>{t.nilai}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                :<p style={{textAlign:'center', color:'#9b9b9b',fontSize:'14px'}}>Tidak Ada Data</p>

                        }


                    </div>

                }
                </div>
        </div>
    )
}

export default DetailPenialaianGuru